import type { RouteRecordRaw, Router } from 'vue-router'

const FraudRoutes: RouteRecordRaw = {
  path: '/claim/fraud',
  name: 'FraudModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'FraudMainRoute',
      component: () => import('./views/FraudView.vue'),
      meta: {
        title: 'fraud.fraudClaims',
      },
    },
    {
      path: 'create',
      name: 'FraudCreateRoute',
      component: () => import('./views/FraudUpsertView.vue'),
      meta: {
        title: 'fraud.createFraud',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:fraudId',
      name: 'FraudEditRoute',
      component: () => import('./views/FraudUpsertView.vue'),
      meta: {
        title: 'fraud.editFraud',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:fraudId',
      name: 'ViewFraudRoute',
      component: () => import('./views/SingleFraudView.vue'),
      meta: {
        title: 'fraud.ViewFraud',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(FraudRoutes)
}
